import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Ask the backend which Clerk instance to use, and fall back to the build-time key only if that
 * fails. A React bundle freezes its own env vars at build time, so a production build can end up
 * signing people in against the development instance while the backend verifies tokens against
 * the live one - a mismatch where no code can ever work. Taking the key from the same process
 * that verifies the tokens makes the two impossible to disagree.
 */
const Bootstrap = () => {
  const [publishableKey, setPublishableKey] = React.useState(null);

  React.useEffect(() => {
    let active = true;
    fetch(`${BACKEND_URL}/api/auth/config`)
      .then((response) => (response.ok ? response.json() : null))
      .then((config) => {
        if (!active) return;
        setPublishableKey(config?.clerk_publishable_key || process.env.REACT_APP_CLERK_PUBLISHABLE_KEY);
      })
      .catch(() => {
        if (active) setPublishableKey(process.env.REACT_APP_CLERK_PUBLISHABLE_KEY);
      });
    return () => {
      active = false;
    };
  }, []);

  if (!publishableKey) {
    return <div style={{ minHeight: "100vh", background: "rgb(250, 250, 249)" }} />;
  }

  return (
    <ClerkProvider publishableKey={publishableKey}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ClerkProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Bootstrap />
  </React.StrictMode>,
);
